import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject, zip } from 'rxjs';
import { AppInitService } from '../../services/app-init.service';

@Injectable({
  providedIn: 'root',
})
export class MainService {

  moduleUrl=[];
  private _refreshNavDataBehaviorSubject: Subject<unknown>;

  constructor(
    private http: HttpClient,
    private appInitService: AppInitService
  ) {
    this._refreshNavDataBehaviorSubject = new Subject();
  }

  get refreshNavDataBehaviorSubject(): Subject<unknown> {
    return this._refreshNavDataBehaviorSubject;
  }

  get refreshNavData$(): Observable<unknown> {
    return this.refreshNavDataBehaviorSubject.asObservable();
  }

  refreshNavData(data: unknown[] = []) {
    this.refreshNavDataBehaviorSubject.next(data);
  }

  getNavData(loadUserPriv = true, loadDevNodes = true, loadTestNodes = true) {
    let accessParams = new HttpParams();
    accessParams = accessParams.append('previlageId', 100);
    accessParams = accessParams.append('privType', 53);
    if (this.appInitService.appConfig.privSubType) {
      accessParams = accessParams.append(
        'privSubType',
        this.appInitService.appConfig.privSubType
      );
    }
    if (this.appInitService.appConfig.privSubTypeVal) {
      accessParams = accessParams.append(
        'privSubTypeVal',
        this.appInitService.appConfig.privSubTypeVal
      );
    }

    return zip(
      this.http.get('/core/quick-links/3000446?').pipe(
        map((response: any) => response?.data),
        catchError((error) => of(null))
      ),
      loadUserPriv
        ? this.http
            .get('/access-control/user-privileges', {
              params: accessParams,
            })
            .pipe(
              map((data) => data),
              catchError((error) => of(null))
            )
        : of(null),
      loadDevNodes
        ? this.http.get('assets/config/dev-nodes.json').pipe(
            map((response: any) => response?.['dev-nodes']),
            catchError((error) => of(null))
          )
        : of(null),
      loadTestNodes
        ? this.http.get('assets/config/test-nodes.json').pipe(
            map((response: any) => response?.['test-nodes']),
            catchError((error) => of(null))
          )
        : of(null)
    );
  }
}
